import { courseProgressConsts } from "../constants/courseProgressConsts"
import { workbooksConstants } from "../constants/workbooksConstants"

const initialState = {
  items: {},
  itemBanks: {},
  allItemBanks: {},
  // fetchingProgressItems: false,
  // progressItemsError: null,
  lessons: {},
  // fetchingProgressLessons: false,
  // progressLessonsError: null,
  sections: {},
  // fetchingProgressSections: false,
  // progressSectionsError: null,
  subcourses: {},
  // fetchingProgressSubcourses: false,
  // progressSubcoursesError: null,
  course: {},
  fetchingCourseProgress: false,
  fetchingAllItemBanks: false,
  initializingTest: false,
  courseProgressError: null,
  allItemBanksFetchError: null,
  studentActivity: [],
  studentActivityError: false,
  addingStudentActivity: false,
  toggleStudentLessonStatus: false,
  studentLessonStatusErr: null,
  toggleStudentLessonComplete: false,
  studentLessonCompleteErr: null,
  changingLessonStatus: ""
}

export function courseProgress(state = initialState, action) {
  switch (action.type) {
    case courseProgressConsts.GET_STUDENTS_COURSE_ITEM_BANKS:
      return {
        ...state,
        fetchingAllItemBanks: true
      }
    case courseProgressConsts.GET_STUDENTS_COURSE_ITEM_BANKS_SUCCESS:
      return {
        ...state,
        allItemBanks: { ...action.data },
        fetchingAllItemBanks: false
      }
    case courseProgressConsts.GET_STUDENTS_COURSE_ITEM_BANKS_FAILURE:
      return {
        ...state,
        fetchingAllItemBanks: false,
        allItemBanksFetchError: action.error
      }
    case courseProgressConsts.GET_STUDENT_COURSE_PROGRESS:
      return {
        ...state,
        fetchingCourseProgress: true
      }
    case courseProgressConsts.GET_STUDENT_COURSE_PROGRESS_SUCCESS:
      return {
        ...state,
        ...action.data,
        fetchingCourseProgress: false
      }
    case courseProgressConsts.GET_STUDENT_COURSE_PROGRESS_FAILURE:
      return {
        ...state,
        fetchingCourseProgress: false,
        courseProgressError: action.error
      }
    case courseProgressConsts.INIT_EXIT_TICKET:
      return {
        ...state,
        initializingTest: true
      }
    case courseProgressConsts.INIT_EXIT_TICKET_SUCCESS:
      const updatedCourseItems = { ...state.items }
      const updatedItemBanks_init = { ...state.itemBanks }

      action.data.items.forEach(it => {
        updatedCourseItems[it.id] = it
      })

      updatedItemBanks_init[action.data.itemBank.id] = action.data.itemBank
      return {
        ...state,
        items: updatedCourseItems,
        itemBanks: updatedItemBanks_init,
        initializingTest: false
      }
    case courseProgressConsts.INIT_EXIT_TICKET_FAILURE:
      return {
        ...state,
        initializingTest: false,
        initializingTestError: action.error
      }
    case courseProgressConsts.ADD_STUDENT_ACTIVITY:
      return {
        ...state,
        addingStudentActivity: true
      }
    case courseProgressConsts.ADD_STUDENT_ACTIVITY_SUCCESS:
      let updatedActivity = Array.isArray(state.studentActivity)
        ? [...state.studentActivity]
        : []
      updatedActivity.push(action.data)
      return {
        ...state,
        addingStudentActivity: true,
        studentActivity: updatedActivity
      }
    case courseProgressConsts.ADD_STUDENT_ACTIVITY_FAILURE:
      return {
        ...state,
        addingStudentActivity: true,
        studentActivityError: action.error
      }
    case courseProgressConsts.CHANGE_LESSON_STATUS:
      return {
        ...state,
        changingLessonStatus: action.lessonId
      }
    case courseProgressConsts.CHANGE_LESSON_STATUS_SUCCESS:
      const updatedLessons = { ...state.lessons }
      updatedLessons[action.data.id] = action.data
      return {
        ...state,
        lessons: updatedLessons,
        changingLessonStatus: ""
      }
    case courseProgressConsts.CHANGE_LESSON_STATUS_FAILURE:
      return {
        ...state,
        changingLessonStatus: ""
      }
    case courseProgressConsts.UPDATE_ITEM_ANSWER:
      return {
        ...state,
        updatingItem: true
      }
    case courseProgressConsts.UPDATE_ITEM_ANSWER_SUCCESS:
      const updatedItems = { ...state.items }
      updatedItems[action.data.id] = action.data
      return {
        ...state,
        items: updatedItems,
        updatingItem: false
      }
    case courseProgressConsts.UPDATE_ITEM_ANSWER_FAILURE:
      return {
        ...state,
        updatingItem: false
      }

    case courseProgressConsts.UPDATE_COURSE_PROGRESS:
      return {
        ...state,
        updatingCourseProgress: true
      }
    case courseProgressConsts.UPDATE_COURSE_PROGRESS_SUCCESS:
      const updatedSections = { ...state.sections }
      const updatedSubcourses = { ...state.subcourses }
      let updatedCourse = { ...state.course }
      const updatedItemBanks = { ...state.itemBanks }
      updatedSections[action.data.section.id] = action.data.section
      updatedSubcourses[action.data.subcourse.id] = action.data.subcourse
      updatedItemBanks[action.data.itemBank.id] = action.data.itemBank
      updatedCourse = action.data.course

      return {
        ...state,
        sections: updatedSections,
        subcourses: updatedSubcourses,
        course: updatedCourse,
        itemBanks: updatedItemBanks,
        updatingCourseProgress: false
      }
    case courseProgressConsts.UPDATE_STUDENT_NODE_DATA:
      return {
        ...state,
        updatingStudentNodeData: true
      }
    case courseProgressConsts.UPDATE_STUDENT_NODE_DATA_SUCCESS:
      return {
        ...state,
        updatingStudentNodeData: false
      }
    case courseProgressConsts.UPDATE_STUDENT_NODE_DATA_FAILURE:
      return {
        ...state,
        updatingStudentNodeData: false,
        errorStudentNodeData: action.error
      }
    case workbooksConstants.TOGGLE_STUDENT_LESSON_STATUS:
      return {
        ...state,
        toggleStudentLessonStatus: action.lessonId
      }
    case courseProgressConsts.SET_DEFAULT_USER_CP:
      return {
        ...initialState
      }
    case workbooksConstants.TOGGLE_STUDENT_LESSON_STATUS_SUCCESS:
      return {
        ...state,
        toggleStudentLessonStatus: false,
        lessons: {
          ...state.lessons,
          [action.lesson.id]: action.lesson
        }
      }
    case workbooksConstants.TOGGLE_STUDENT_LESSON_STATUS_FAILURE:
      return {
        ...state,
        toggleStudentLessonStatus: false,
        studentLessonStatusErr: action.payload
      }
    case workbooksConstants.TOGGLE_ALL_STUDENT_LESSON_STATUS:
      return {
        ...state,
        toggleAllStudentLessonStatus: true
      }
    case workbooksConstants.TOGGLE_ALL_STUDENT_LESSON_STATUS_SUCCESS:
      return {
        ...state,
        toggleAllStudentLessonStatus: false,
        lessons: {
          ...state.lessons,
          ...action.lessonStudents
        }
      }
    case workbooksConstants.TOGGLE_ALL_STUDENT_LESSON_STATUS_FAILURE:
      return {
        ...state,
        toggleAllStudentLessonStatus: false,
        allStudentLessonStatusErr: action.payload
      }

    case workbooksConstants.TOGGLE_STUDENT_LESSON_COMPLETE:
      return {
        ...state,
        toggleStudentLessonComplete: action.lessonId
      }
    case workbooksConstants.TOGGLE_STUDENT_LESSON_COMPLETE_SUCCESS:
      return {
        ...state,
        toggleStudentLessonComplete: false,
        lessons: {
          ...state.lessons,
          [action.lesson.id]: action.lesson
        }
      }
    case workbooksConstants.TOGGLE_STUDENT_LESSON_COMPLETE_FAILURE:
      return {
        ...state,
        toggleStudentLessonComplete: false,
        studentLessonCompleteErr: action.payload
      }

    default:
      return state
  }
}
